/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {SVGMappingDocument} from './SVGMappingDocument';
import {KorrespondenzSprache} from '../../../../core/sprache.enum';

export class SVGPlaceholder<T> {

    public constructor(
        public readonly placeholder: string,
        private readonly formatter: (value: T, sprache: KorrespondenzSprache) => string
    ) {
    }

    public write(document: SVGMappingDocument, value: T, sprache: KorrespondenzSprache): void {
        document.result = document.result.replace(this.placeholder, this.formatter(value, sprache));
    }
}
